import React from 'react';
import PropTypes from 'prop-types';
import MetricsGrid from './MetricsGrid';
import StatusChart from './StatusChart';
import PJProjectsChart from './PJProjectsChart';
import CSEStatisticsTable from './CSEStatisticsTable';
import CSEStatisticsChart from './CSEStatisticsChart';
import DetailedChangeOrderList from './DetailedChangeOrderList';
import ShopDrawingAnalysis from './ShopDrawingAnalysis';
import SalesUnitChart from './SalesUnitChart';

const slot = (state) => ({ loading: state.loading, error: state.error });

/**
 * Volume view of the dashboard: how many change orders, where they come from,
 * who handles them. Ordered headline → mix → workload → evidence; the two
 * donuts share a row so the mix reads at a glance on a wide screen.
 */
const OverviewTab = ({ state, onPageChange, onRequestExport, jobNumber, onJobNumberChange }) => {
  const { summary, statusDistribution, cseStatistics, shopDrawingAnalysis, detailedChangeOrders, salesUnitStatistics } = state;

  return (
    <div className="tw-space-y-6">
      <MetricsGrid summary={summary.data} {...slot(summary)} />

      <div className="tw-grid tw-grid-cols-1 2xl:tw-grid-cols-2 tw-gap-6">
        <StatusChart data={statusDistribution.data} {...slot(statusDistribution)} />
        <PJProjectsChart summary={summary.data} {...slot(summary)} />
      </div>

      <SalesUnitChart data={salesUnitStatistics.data} {...slot(salesUnitStatistics)} />

      <CSEStatisticsChart data={cseStatistics.data} {...slot(cseStatistics)} />
      <CSEStatisticsTable data={cseStatistics.data} {...slot(cseStatistics)} />

      <ShopDrawingAnalysis data={shopDrawingAnalysis.data} {...slot(shopDrawingAnalysis)} />

      <DetailedChangeOrderList
        data={detailedChangeOrders.data}
        pagination={detailedChangeOrders.pagination}
        {...slot(detailedChangeOrders)}
        onPageChange={onPageChange}
        onRequestExport={onRequestExport}
        jobNumber={jobNumber}
        onJobNumberChange={onJobNumberChange}
      />
    </div>
  );
};

OverviewTab.propTypes = {
  state:             PropTypes.object.isRequired,
  onPageChange:      PropTypes.func.isRequired,
  onRequestExport:   PropTypes.func.isRequired,
  jobNumber:         PropTypes.string,
  onJobNumberChange: PropTypes.func.isRequired,
};

export default OverviewTab;
